import { render, staticRenderFns } from "./EditPackagePage.vue?vue&type=template&id=385ecc99"
import script from "./EditPackagePage.vue?vue&type=script&lang=js"
export * from "./EditPackagePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports